import { IntegrationModule } from 'components/Integrations/integration-modules/integration-module.types';
import { GruntworxIntegrationListItem } from './GruntworxIntegrationListItem';
import { GruntworxIntegrationConfig } from './GruntworxIntegrationConfig';
import { getGruntworxActivationStatus } from './gruntworx-calls';

export const gruntworxIntegrationModule: IntegrationModule = {
  id: 'gruntworx',
  path: 'gruntworx',
  title: 'GruntWorx',
  getActivationStatus: getGruntworxActivationStatus,
  listComponent: <GruntworxIntegrationListItem />,
  configComponent: <GruntworxIntegrationConfig />,
}; 